 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		22: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		22: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"127ce695dff37b738f1aaef110fe4228479f47af","3":"480dbe8ca8008a874410483fb318a0df6ba0a777","4":"29107295","5":"4f221fcc0912d77c400be56c937e6a48ae65c8ae","6":"52788abb4c47a4f0c41a335931657ea3c4bceab2","7":"e7e453c3c006eda14145e6a843fa795e5632c555","8":"efceb268eb1a6ee26eb4e9d670b55ce1848a099c","9":"1a891860806d4cf9695c291b62091827dccbbb04","10":"4ed175da7309c65357e4f48471a9568314abe480","11":"ccdbcc78135bd28c358f60f77fee0155b9ebf0e7","12":"e00da47c7ac49887f27253655b3161a9b939d8c7","13":"502647e7216413cb5ae040f98c21e9bbfa8ec6e5","14":"4147a008dba6b54baa9d6e20f2e4792a99cd5398","15":"6ec5fd93b295eb3bec4b58753ad4995ef73c37c8","16":"ceef7a220c2c87dcd1dcd95f7fe52de9aeecaa22","17":"f12de619e5b4aeddf7f8472a2e6f27cb3973f0c5","18":"0a0f6fc5a9aba59cd65e58ca59dbf844b7e88613","19":"e547e3b3c6b65d544b78fb04be97186b13e51bbb","20":"5a347dbd54b6402a5e92ea2672a8f5983e7c8da0","21":"843269161dd8825bd423d11ebb4a7bc9f2b9dff4","24":"72a30a16","26":"component---src-pages-404-js","27":"component---src-pages-about-index-js","28":"component---src-pages-b-2-b-index-js","29":"component---src-pages-b-2-b-thanks-js","30":"component---src-pages-blog-index-js","31":"component---src-pages-contact-examples-js","32":"component---src-pages-contact-file-upload-js","33":"component---src-pages-contact-index-js","34":"component---src-pages-contact-thanks-js","35":"component---src-pages-exploremore-circulardesign-index-js","36":"component---src-pages-exploremore-communication-index-js","37":"component---src-pages-exploremore-designthinking-index-js","38":"component---src-pages-exploremore-gamedesign-index-js","39":"component---src-pages-exploremore-index-js","40":"component---src-pages-exploremore-industrial-index-js","41":"component---src-pages-exploremore-productdesign-index-js","42":"component---src-pages-exploremore-storytelling-index-js","43":"component---src-pages-exploremore-webandapplication-index-js","44":"component---src-pages-faq-index-js","45":"component---src-pages-index-js","46":"component---src-pages-index-old-js","47":"component---src-pages-info-index-js","48":"component---src-pages-media-index-js","49":"component---src-pages-oops-index-js","50":"component---src-pages-partner-index-js","51":"component---src-pages-payment-index-js","52":"component---src-pages-play-demo-index-js","53":"component---src-pages-privacy-index-js","54":"component---src-pages-privacy-index-olc-js","55":"component---src-pages-product-a-index-js","56":"component---src-pages-product-index-js","57":"component---src-pages-programmes-index-js","58":"component---src-pages-report-index-js","59":"component---src-pages-schoolsolution-index-js","60":"component---src-pages-schoolsolution-thanks-js","61":"component---src-pages-skills-index-js","62":"component---src-pages-tags-index-js","63":"component---src-pages-term-index-1-js","64":"component---src-pages-term-index-js","65":"component---src-pages-thankyou-index-js","66":"component---src-templates-blog-post-js","67":"component---src-templates-index-page-js","68":"component---src-templates-product-page-js","69":"component---src-templates-tags-js","70":"e78312c5"}[chunkId]||chunkId) + "-" + {"0":"d62805de97e18c99c1da","1":"c2fe8482057191dca484","2":"efdc35b3d46689917535","3":"1ff972b2f8c33941f2e5","4":"d2ccfaf66de8a305900c","5":"e0c7aa0ece3f7a4090ca","6":"5d75d12e9b44c094d592","7":"3f6d124627808967bca8","8":"e46166d460d2efc0688e","9":"1dd7ff5964897e200287","10":"a56fb277aeb40fafb4cb","11":"50366087a4218fa6ecc4","12":"966eb68796dc57d1f250","13":"ffd1f28ac105fd13c98f","14":"f6722b28cfeba5bf36c6","15":"ab7e09231c7eccfdb7a6","16":"f7164cb333d6b8dffb72","17":"b15cf839a2d1bc5e5d26","18":"d48b6ed4f0384510eebb","19":"b1b5c8037e9f9c3cea6c","20":"6e2daa73445ac5bad8fc","21":"437e8991b43d1c843658","24":"f876c712160c59cfa712","26":"a66e3b154621397f93da","27":"954c3f4504ed5df6a7cb","28":"d6db8820544fe28c9eb5","29":"80b31db7dd6310c16601","30":"4b70d881ba494b9e1d6f","31":"ae3bb86569bf34b12299","32":"1242504d2d5b06036b32","33":"3787435f84dda4cd3a74","34":"436ebe300d838f6efb65","35":"c8143a3d75ca99270c52","36":"32902c084eb5d87b7e39","37":"ef2898a4f2b54052226a","38":"6b29b011db103fb82c5b","39":"9cb491c517403644357e","40":"30b8815ac9a2b3b66572","41":"09b10a4ec0c70aa455b9","42":"35d45b1b2eacb62feb2a","43":"f70b3bab21feeb85ec2b","44":"404d215cfaffc86e0c6e","45":"88e34148acdb3ad40d23","46":"5434db01c45a71b5764a","47":"3197f1cfb49998d8f0e8","48":"8cc5fb27aadc24650ab5","49":"a7cec9403c8f8440f148","50":"e757103adae0b2bb8af7","51":"402f369c021fb3cf775e","52":"cb5bb3ec7f2b746da07a","53":"a17d98c96fa3197fa98b","54":"64a687fa695ebf9a2378","55":"248813db17cdcb671516","56":"2b238a95c58684fbd6ec","57":"c99d0787cd9a06290f70","58":"7ddefa1a41b2a13d5088","59":"36e7e47a0e05aa480379","60":"a66b3eb3183125983fab","61":"17b6db06133e5321c9cc","62":"e922daac06a98f5a317c","63":"d7632ff354f35aaa183e","64":"5d89264aa4215da04fe3","65":"ae7cff56edebed92e472","66":"396feff0e5be865608cf","67":"8bd3a3474ca0163464b6","68":"b706d79aafaf70677c14","69":"a42d1088d6e5f06f8f33","70":"4bd853457eb3b4b1724e","73":"9a65f4ee2ec6cf3d3c25","74":"1439b6bdc554a77650ea","75":"ecdcba5d952b2bdbeef2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"127ce695dff37b738f1aaef110fe4228479f47af","3":"480dbe8ca8008a874410483fb318a0df6ba0a777","4":"29107295","5":"4f221fcc0912d77c400be56c937e6a48ae65c8ae","6":"52788abb4c47a4f0c41a335931657ea3c4bceab2","7":"e7e453c3c006eda14145e6a843fa795e5632c555","8":"efceb268eb1a6ee26eb4e9d670b55ce1848a099c","9":"1a891860806d4cf9695c291b62091827dccbbb04","10":"4ed175da7309c65357e4f48471a9568314abe480","11":"ccdbcc78135bd28c358f60f77fee0155b9ebf0e7","12":"e00da47c7ac49887f27253655b3161a9b939d8c7","13":"502647e7216413cb5ae040f98c21e9bbfa8ec6e5","14":"4147a008dba6b54baa9d6e20f2e4792a99cd5398","15":"6ec5fd93b295eb3bec4b58753ad4995ef73c37c8","16":"ceef7a220c2c87dcd1dcd95f7fe52de9aeecaa22","17":"f12de619e5b4aeddf7f8472a2e6f27cb3973f0c5","18":"0a0f6fc5a9aba59cd65e58ca59dbf844b7e88613","19":"e547e3b3c6b65d544b78fb04be97186b13e51bbb","20":"5a347dbd54b6402a5e92ea2672a8f5983e7c8da0","21":"843269161dd8825bd423d11ebb4a7bc9f2b9dff4","24":"72a30a16","26":"component---src-pages-404-js","27":"component---src-pages-about-index-js","28":"component---src-pages-b-2-b-index-js","29":"component---src-pages-b-2-b-thanks-js","30":"component---src-pages-blog-index-js","31":"component---src-pages-contact-examples-js","32":"component---src-pages-contact-file-upload-js","33":"component---src-pages-contact-index-js","34":"component---src-pages-contact-thanks-js","35":"component---src-pages-exploremore-circulardesign-index-js","36":"component---src-pages-exploremore-communication-index-js","37":"component---src-pages-exploremore-designthinking-index-js","38":"component---src-pages-exploremore-gamedesign-index-js","39":"component---src-pages-exploremore-index-js","40":"component---src-pages-exploremore-industrial-index-js","41":"component---src-pages-exploremore-productdesign-index-js","42":"component---src-pages-exploremore-storytelling-index-js","43":"component---src-pages-exploremore-webandapplication-index-js","44":"component---src-pages-faq-index-js","45":"component---src-pages-index-js","46":"component---src-pages-index-old-js","47":"component---src-pages-info-index-js","48":"component---src-pages-media-index-js","49":"component---src-pages-oops-index-js","50":"component---src-pages-partner-index-js","51":"component---src-pages-payment-index-js","52":"component---src-pages-play-demo-index-js","53":"component---src-pages-privacy-index-js","54":"component---src-pages-privacy-index-olc-js","55":"component---src-pages-product-a-index-js","56":"component---src-pages-product-index-js","57":"component---src-pages-programmes-index-js","58":"component---src-pages-report-index-js","59":"component---src-pages-schoolsolution-index-js","60":"component---src-pages-schoolsolution-thanks-js","61":"component---src-pages-skills-index-js","62":"component---src-pages-tags-index-js","63":"component---src-pages-term-index-1-js","64":"component---src-pages-term-index-js","65":"component---src-pages-thankyou-index-js","66":"component---src-templates-blog-post-js","67":"component---src-templates-index-page-js","68":"component---src-templates-product-page-js","69":"component---src-templates-tags-js","70":"e78312c5"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"701cac2e57d594321c94","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
